<ng-template #ConfirmInsuredTripCancelation>
  <div class="modal-form-confirm-cancelation">
    <div nxRow>
      <div nxCol="12">
        <h3 nxHeadline="subsection-medium" class="nx-font-weight-semibold"
          translate>
          policy.insured-trips.edit.cancelation.title</h3>
      </div>
    </div>
    <div nxRow>
      <div nxCol="12">
        <form [formGroup]="confirmForm" (submit)="submitConfirmation($event)" class="form-buttons">
          <button nxButton="secondary normal" type="button"
            (click)="closeModal()"><span
              translate>policy.insured-trips.back-btn</span></button>
          <button nxButton="primary normal" type="submit"><span
              translate>policy.insured-trips.edit.cancelation.submit-btn</span></button>
        </form>
      </div>
    </div>
  </div>
</ng-template>
